import { createPlatformCommandService } from '../application/createPlatformCommandService';
import { supabasePlatformWritePort } from '../infrastructure/supabasePlatformWritePort';

export const platformCommandService = createPlatformCommandService(supabasePlatformWritePort);
